import { appConfig } from '_/config/app';

export const QRCODE_SLOT_PREFIX = `${appConfig.spaceManagement.prefixQrCode}slot/`;
export const QRCODE_LOCATION_PREFIX = `${appConfig.spaceManagement.prefixQrCode}location/`;
export const QRCODE_SPACE_PREFIX = `${appConfig.spaceManagement.prefixQrCode}space/`;
